<div class="tab-route-container">
    <div class="px-4"></div>
    <div *ngFor="let item of items" 
        [routerLink]="item.link" 
        [class.active]="isActive(item)" 
        class="tab-route">
        {{item.title | translate}}
    </div>
</div>